import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import './RecordStaticInformation.css';
import RecordDownloadLinks from './RecordDownloadLinks';
import VideoPreview from './VideoPreview';
import RecordShareInformation from './RecordShareInformation';
import useVideos from "../../hooks/useVideos";
import useChapterCues from '../../hooks/useChapterCues';
import Carousel from '../utilities/Carousel';
import RecordViews from "./RecordViews";
import { useTranslation } from 'react-i18next';

const VideoPreviewLabel = ({ video }) => {
  return <div className="video-preview-label">
    <span>{video.resolution}</span>
  </div>
};

const RecordStaticInformation = ({ record, refreshChapters = 0 }) => {
    const { t, i18n } = useTranslation();
    const [previewStartTime, setPreviewStartTime] = useState(0);
    const videos = useVideos(record.identifier);
    const chaptersByLanguage = useChapterCues(record.identifier, refreshChapters);
    const publishedLink = `${process.env.REACT_APP_KATSOMO_PUBLISHED_LINK_URL}${record.identifier}`;
    const isPublished = !(record?.visibility || []).includes('status_private');
    const previewFooter = (
        <div className="record-player-footer">
            <div className="record-views">
                <RecordViews views={record.views} created={record.created} duration={record.duration} />
            </div>
            <div className="record-player-actions">
                <RecordShareInformation
                    identifier={record.identifier}
                    publishedLink={publishedLink}
                    isPublished={isPublished}
                    title={record.title}
                    startFrom={previewStartTime}
                />
                <RecordDownloadLinks downloadableMedia={record.downloadableMedia} title={record.title} />
            </div>
        </div>
    );

    return (
        <Container className="ps-0">
            <div className="record-form-section">
                <h2 className="record-form-section-header">{t('record_static_section_video')}</h2>
                <Row>
                    <Col>
                      <Carousel labels={videos.map((video, i) => <VideoPreviewLabel video={video} key={video.url} />)} previousAriaLabel={'record_video_carousel_previous_aria'} nextAriaLabel={'record_video_carousel_next_aria'}>
                        {videos.map((video) => (
                          <VideoPreview
                            key={video.url}
                            video={video}
                             chaptersByLanguage={Object.keys(chaptersByLanguage).length > 0 ? chaptersByLanguage : video.chaptersByLanguage}
                             interfaceLanguage={i18n.language}
                             previewFooter={previewFooter}
                             onTimeUpdate={setPreviewStartTime}
                           />
                        ))}
                      </Carousel>
                    </Col>
                </Row>
                {videos.length === 0 && <Row><Col>{previewFooter}</Col></Row>}
            </div>
        </Container>
    );
};

RecordStaticInformation.propTypes = {
    record: PropTypes.object,
    refreshChapters: PropTypes.number,
};

export default RecordStaticInformation;
